var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"wac-cms-social-media-link",attrs:{"href":_vm.url,"title":_vm.title,"target":"blank"}},[_c('wac-icon',{attrs:{"variant":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }